import { getSavedConfig } from "./utils"

const TREEGRID_CODE = process.env.REACT_APP_TREEGRID_CODE
const isDevelopmentEnv = process.env.NODE_ENV === "development"

export const makeCfgBase = ({ id, cfgId = id }: { id: string; cfgId?: string }) => {
  /** @link link for documentation: https://www.treegrid.com/Doc/SearchAttr.html */
  return {
    Code: TREEGRID_CODE,
    id,
    CfgId: cfgId, // Id used for saving config to localStorage
    SuppressCfg: isDevelopmentEnv ? 1 : 0,

    // Config related to styles and appreance
    Style: "white", // Base treegrid style
    GanttStyle: "Material", // Base Gantt style
    WordWrap: 0,

    // Scroll positions
    ScrollLeft: 0, // sets initial horizontal scroll of middle (variable) columns, in pixels.
    LeftScrollLeft: 0, // sets initial horizontal scroll of left columns, in pixels.
    RightScrollLeft: 0, // sets initial horizontal scroll of right columns, in pixels.
    SyncScroll: 1, // syncs horizontal scroll between header and body

    // Config related to resizing
    LeftCanResize: 4, // Allow resizing at all times
    RightCanResize: 4, // Allow resizing at all times
    SectionShrinkOrder: ["Right,Mid,Left"], // shrinks right first if width is not enough to render all sections

    // Config related to interaction
    Selecting: 0, // disables selecting of rows
    Dragging: 0, // disables dragging of rows

    // Config related to printing
    PrintVisible: 1, // // Prints only the currently visible (scrolled/zoomed) horizontal part of the Gantt chart
    PrintExpanded: 1, // Prints all rows expanded
    PrintPageOrientation: 1, // 1 for Landscape, 0 for Portrait
    PrintPaddingHeight: 20, // Reserved height on page (in pixels), for other content on page
    PDFFitPage: 1, // Shrinks or resizes the printed grid to be printed in one page in given direction

    // Config related to saving and restoring settings
    PersistentCfg: 1, // Save config to localStorage instead of cookies
    Cookie: getSavedConfig(cfgId), // Load saved config from localStorage
    FilterLap: 1, // Don't save the filter settings in the localStorage
    SortLap: 1, // Don't save the sort settings in the localStorage
    SearchLap: 1, // Don't save the search settings in the localStorage
    GanttLap: 1, // Don't save the Gantt settings in the localStorage

    // Config related to treegrid behavior
    SearchAction: "Filter", // <Filter> action Hides all rows that don't match the SearchExpression
  }
}
